import {
  enumPurchaseLineItemType,
  enumUnit,
  PurchaseLineItemType,
  SalesItemLineType,
  Unit,
} from '@rematter/frontend-lib-api-client';
import { zeroWeight } from '@rematter/modules/trade/utils/weight';
import { v4 as uuidv4 } from 'uuid';

import {
  enumLineItemKind,
  type LineItemAdapter,
  type NormalizedLineItem,
} from '../_types';

import {
  enumLoadWeightType,
  LoadFormLineItem,
} from '~/modules/trade/types/load';

export const parseSalesLoadLineItem: LineItemAdapter<
  LoadFormLineItem,
  PurchaseLineItemType
> = {
  toNormalized: (item: LoadFormLineItem): NormalizedLineItem => ({
    kind: enumLineItemKind.LineItem,
    id: item.id,
    type: item.type ?? enumPurchaseLineItemType.Raw,
    itemId: item.itemId ?? null,
    tagId: item.tagId ?? null,
    weights: item.weights
      ? {
          [enumLoadWeightType.Gross]: item.weights[enumLoadWeightType.Gross],
          [enumLoadWeightType.Tare]: item.weights[enumLoadWeightType.Tare],
          [enumLoadWeightType.Net]: item.weights[enumLoadWeightType.Net],
        }
      : null,
    unitPrice: item.unitPrice ?? null,
    pricingUnit: (item.pricingUnit as Unit) ?? enumUnit.Pounds,
    notes: null,
  }),

  fromNormalized: (
    normalized: NormalizedLineItem,
    original?: LoadFormLineItem,
  ): LoadFormLineItem => ({
    ...original,
    id: normalized.id,
    type: normalized.type as SalesItemLineType,
    itemId: normalized.itemId,
    tagId: normalized.tagId,
    weights: {
      [enumLoadWeightType.Gross]:
        normalized.weights?.[enumLoadWeightType.Gross] ?? null,
      [enumLoadWeightType.Tare]:
        normalized.weights?.[enumLoadWeightType.Tare] ?? null,
      [enumLoadWeightType.Net]:
        normalized.weights?.[enumLoadWeightType.Net] ?? null,
    },
    unitPrice: normalized.unitPrice,
    pricingUnit: normalized.pricingUnit,
  }),

  createEmpty: (
    type: PurchaseLineItemType,
    partial?: Partial<NormalizedLineItem>,
  ): LoadFormLineItem => {
    const unit: Unit = partial?.pricingUnit ?? enumUnit.Pounds;
    return {
      id: partial?.id ?? `temp-${uuidv4()}`,
      type: partial?.type as SalesItemLineType,
      itemId: partial?.itemId ?? null,
      tagId: partial?.tagId ?? null,
      weights: {
        [enumLoadWeightType.Gross]:
          partial?.weights?.[enumLoadWeightType.Gross] ?? zeroWeight(),
        [enumLoadWeightType.Tare]:
          partial?.weights?.[enumLoadWeightType.Tare] ?? zeroWeight(),
        [enumLoadWeightType.Net]:
          partial?.weights?.[enumLoadWeightType.Net] ?? zeroWeight(),
      },
      unitPrice: partial?.unitPrice ?? null,
      pricingUnit: unit,
    };
  },
};
